import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "owner" ? "/dashboard" : "/jobs");
    } catch (err) {
      toast.error(formatApiError(err));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background noise-overlay flex items-center justify-center px-4" data-testid="login-page">
      <Card className="w-full max-w-md rounded-2xl border-border">
        <CardContent className="p-8 sm:p-10">
          <Link to="/" className="flex items-center gap-2 mb-8" data-testid="login-logo-link">
            <img src="/brand/logo.jpg" alt="Blake's Mowing and Odd Jobs logo" className="h-10 w-10 rounded-full object-cover" />
            <span className="font-display font-bold text-lg tracking-tight">Blake&apos;s Mowing &amp; Odd Jobs</span>
          </Link>
          <h1 className="text-2xl sm:text-3xl tracking-tight font-semibold mb-2">Staff login</h1>
          <p className="text-sm text-muted-foreground mb-8">Owner and employee access to jobs & schedule.</p>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="login-email" className="text-xs uppercase tracking-[0.2em] font-semibold">Email</Label>
              <Input id="login-email" data-testid="login-email-input" type="email" required autoComplete="email"
                value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 mt-2 rounded-xl" />
            </div>
            <div>
              <Label htmlFor="login-password" className="text-xs uppercase tracking-[0.2em] font-semibold">Password</Label>
              <Input id="login-password" data-testid="login-password-input" type="password" required autoComplete="current-password"
                value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 mt-2 rounded-xl" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit-button"
              className="w-full h-12 rounded-full bg-primary hover:bg-[#21421D] text-white transition-colors">
              {loading ? "Signing in..." : "Sign in"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
